<template>
  <div :style="{ padding: '0 0 10px 32px' }">
    <h4 :style="{ marginBottom: '20px' }">{{ title }}</h4>
    <v-chart :forceFit="true" :height="height" :data="dataSource" :scale="scale" :onClick="handleClick">
      <v-tooltip />
      <v-axis />
      <v-line position="item*value" />
      <v-point position="item*value" shape="circle" />
    </v-chart>
  </div>
</template>

<script>
  import { ChartEventMixins } from './mixins/ChartMixins'

  export default {
    name: 'LineChartBase',
    mixins: [ChartEventMixins],
    props: {
      title: {
        type: String,
        default: ''
      },
      dataSource: {
        type: Array,
        default: () => []
      },
      // fields: {
      //   type: Array,
      //   default: () => []
      // },
      // // 别名
      // aliases:{
      //   type: Array,
      //   default: () => []
      // },
      height: {
        type: Number,
        default: 254
      }
    },
    data() {
      return {
        scale: [{
          dataKey: 'value',
          min: 0,
          formatter: ','
        }],
        style: { stroke: '#fff', lineWidth: 1 }
      };
    }
  };
</script>